import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { Text, TextType } from 'ui-components/components/text';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { messages } from './messages';
import style from './tag-dropdown.module.less';

export const ManageTags = ({ manageTagsAction = null, className }) => {
  if (!manageTagsAction) {
    return null;
  }

  return (
    <DropdownMenuItem className={classnames(style['tag-dropdown-menu-item'], className)} onClick={manageTagsAction}>
      <Text textType={TextType.Paragraph} value={messages.manageTags} />
    </DropdownMenuItem>
  );
};

ManageTags.propTypes = {
  manageTagsAction: PropTypes.func,
  className: PropTypes.string,
};
